export default {
  filmLink (film) {
    return {
      name: "Film",
      params: { id: film.id }
    }
  },
  genreLink (genre) {
    return {
      name: "Films",
      query: { genre }
    }
  },
  countryLink (country) {
    return {
      name: "Films",
      query: { country }
    }
  },
  languageLink (language) {
    return {
      name: "Films",
      query: { language }
    }
  },
  personLink (person) {
    return {
      name: "Films",
      query: { person }
    }
  },
  dateLink (date) {
    return {
      name: "Films",
      query: { year: new Date(date).getFullYear() }
    }
  },
  userLink (user_id) {
    return {
      name: "User",
      params: { id: user_id },
    }
  },
  listLink (list) {
    return {
      name: "List",
      params: { id: list.id },
    }
  },
}
